<template>
  <el-dialog
    append-to-body
    :visible.sync="visible"
    v-if="visible"
    width="80%"
    top="4vh"
    center
    class="Dialog"
    title="应付结算单"
  >
    <div class="dialog-content">
      <sirui-search
        ref="storeDataSearch"
        :query="query"
        :columns="searchFormColumns"
        @resetBtnClick="resetBtnClickHandler"
        @searchBtnClick="queryBtnClickHandler"
      ></sirui-search>
      <div class="main-content">
        <sirui-table
          ref="siruiTable"
          height="300"
          :loading="load"
          :data="tableData"
          :paging="true"
          :setting="false"
          :showToolbar="false"
          :customVisible="false"
          :columns="columnList"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template v-slot="{ row }">
              <template v-if="item.field === 'settlementBusinessType'">{{
                businessCategory?.find((item) => item.value == row['settlementBusinessType'])?.label
              }}</template>
              <template v-else-if="item.field === 'settlementStatus'">{{
                settlementStatus?.find((item) => item.value == row['settlementStatus'])?.label
              }}</template>
              <template v-else-if="item.field === 'paymentStatus'">{{
                pay_paymentStatus?.find((item) => item.value == row['paymentStatus'])?.label
              }}</template>

              <template v-else-if="item.field === 'printFlag'">{{
                row.printFlag == 1 ? '已打印' : '未打印'
              }}</template>
              <!-- <template v-else-if="item.field === 'businessCategory'">{{
              getSettlementBusinessTypeStatus(row.businessCategory)
            }}</template> -->
              <template v-else>{{ row[item.field] }}</template>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" style="margin-top: 15px" @click="visible = false">取消</el-button>
        <el-button type="primary" style="margin-top: 15px" @click="relatedHandler"
          >确定关联</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { searchColumns, defaultTableColumn } from './index.js';
  // , tableList
  import PAYABLES_TRADE from '@/api/receivablesAndPayables/trade.js';

  export default {
    props: {},
    data() {
      return {
        load: false,
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        columnList: defaultTableColumn,
        query: {
          // settlementCompanyNo: '',
          // settlementDepartmentNo: '',
          // settlementStatus: '',
          supplierNo: '',
          contractNoStr: '',
          // settlementType: '1',
          payableSettlementNo: '',
          supplierName: '',
        },
        companyCode: null,
        visible: false,
      };
    },
    computed: {
      searchFormColumns() {
        return searchColumns(this);
      },
      businessCategory() {
        return this.dictListMap?.businessCategory;
      },
      settlementStatus() {
        return this.dictListMap?.settlementStatus;
      },
      pay_paymentStatus() {
        return this.dictListMap?.pay_paymentStatus;
      },
    },
    mounted() {
      this.getTableData();
    },
    methods: {
      openDialog() {
        this.visible = true;
        this.getTableData();
      },

      // 获取表格数据
      async getTableData(pageNum = 1, pageSize = 10) {
        console.log('搜索');
        const postData = {
          ...this.query,
          pageNum,
          pageSize,
        };
        // this.$refs.siruiTable.page.pageNum,
        // this.$refs.siruiTable.page.pageSize,
        const { data } = await this.$axios.post(
          PAYABLES_TRADE.RELATED_PAYBLES_SETTLEMENT_API,
          postData
        );
        this.tableData = data?.data?.records;
        this.$refs.siruiTable.setPageTotal(data?.data?.total);
      },
      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        this.multipleSelection = row;
      },
      //确认关联
      relatedHandler() {
        console.log(this.multipleSelection, 'this.multipleSelection');
        if (!this.multipleSelection.length) {
          this.$message.error('请选择行操作！');
          return;
        }
        this.$emit('relatedHandler', this.multipleSelection);
        this.visible = false;
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索', this.query);
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData(1, this.$refs.siruiTable.page.pageSize);
      },
      // 重置
      resetBtnClickHandler() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData(1, this.$refs.siruiTable.page.pageSize);
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData(this.$refs.siruiTable.page.pageNum, this.$refs.siruiTable.page.pageSize);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    padding-bottom: 5px;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 25px;
      padding: 10px;
      border-bottom: 2px solid #ddd;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
  }
  ::v-deep {
    .el-dialog__body {
      padding: 15px 20px !important;
    }
  }
</style>
